export default `mutation BulkCreateOrders($exampleBulkCreateOrdersInput: BulkCreateOrdersMutationInput!) {
  bulkCreateOrders(input: $exampleBulkCreateOrdersInput) {
    orders {
      id
      claimUrl
    }
    error
  }
}`;
